// applies pseudo entity type names to an entity
// currently used for things like FileAsset which might be PDF documents etc, and could use special images, icons, etc
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import { isFileAsset } from "./is-file-asset";
export var applyPseudoEntityTypeName = function (entity) {
  var _a, _b;
  var PDF_PATTERN = /\.pdf$/i;
  var WORD_PATTERN = /\.docx?$/i;
  var EXCEL_PATTERN = /\.xlsx?$/i;
  var __typename = entity.__typename;
  var url = isFileAsset(entity) && ((_a = entity.file) === null || _a === void 0 ? void 0 : _a.url) || ((_b = entity.openGraph) === null || _b === void 0 ? void 0 : _b.url);
  if (!url) {
    return entity;
  }
  // check the source field's URL 
  if (url.match(PDF_PATTERN)) {
    __typename = "PdfFileAsset";
  } else if (url.match(WORD_PATTERN)) {
    __typename = "WordFileAsset";
  } else if (url.match(EXCEL_PATTERN)) {
    __typename = "ExcelFileAsset";
  }
  // too many ways to store type... argh.
  return __assign(__assign({}, entity), {
    __typename: __typename,
    entityTypeName: __typename,
    __type: __typename,
    _schema: __assign(__assign({}, entity._schema || {}), {
      __typename: __typename
    })
  });
};